import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSmartSearchFeedback.meta';

export type UseTrackSmartSearchFeedbackParams = {
  sentiment: 'thumbs_up' | 'thumbs_down';
};

export const useTrackSmartSearchFeedback = () => {
  const { track } = useAnalyticsUtilities();

  const trackSmartSearchFeedback = useCallback(
    (params: UseTrackSmartSearchFeedbackParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSmartSearchFeedback };
};
